var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn btn-success float-right btn-block",on:{"click":_vm.generarPDF}},[_vm._v("📄 "+_vm._s(_vm.estudiantesSeleccionados.length)+" boletines procesados... Imprimir Boletines o Generar Boletines en PDF")])])}
var staticRenderFns = []

export { render, staticRenderFns }